import { render, staticRenderFns } from "./BonusList.vue?vue&type=template&id=0acf0594&scoped=true&"
import script from "./BonusList.vue?vue&type=script&lang=js&"
export * from "./BonusList.vue?vue&type=script&lang=js&"
import style0 from "./BonusList.vue?vue&type=style&index=0&id=0acf0594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acf0594",
  null
  
)

export default component.exports